module.exports = __webpack_public_path__ + "static/media/left_arrow_white.37f3430a.svg";